import { createI18n, type I18n } from 'vue-i18n'

import nn from './locales/nn.json'
import nb from './locales/nb.json'
import { ref } from 'vue'

const messages = {
  nn,
  nb
}

const options = {
  legacy: false,
  locale: import.meta.env.VUE_APP_I18N_LOCALE || 'nb',
  fallbackLocale: import.meta.env.VUE_APP_I18N_FALLBACK_LOCALE || 'nb',
  messages: messages
}

const i18n: I18n<never, never, never, string, false> = createI18n(options)
const globalInstance = i18n.global

const globalLocale = ref(options.locale)

function setGlobalLocale(locale: string) {
  const idx = globalInstance.availableLocales.findIndex((obj) => obj == locale)
  if (idx >= 0) {
    globalInstance.locale.value = globalInstance.availableLocales[idx]!
    globalLocale.value = globalInstance.availableLocales[idx]
  }
}

function getGlobalLocale() {
  return globalLocale.value
}

export { i18n, setGlobalLocale, getGlobalLocale }

export default globalInstance
